export const mobile = "(max-width: 600px)";
export const tablet = "(max-width: 900px)";
export const desktop = "(max-width: 1200px)";
export const desktopL = "(min-width: 1200px)";
